<ngb-datepicker data-testid="SUBSYS2_DASHBOARD_CALENDAR_DATEPICKER" class="dashboard-calendar w-100"
	[dayTemplate]="customDay" [outsideDays]="'hidden'" [showWeekNumbers]="true" [dayTemplateData]="dayTemplateData"
	(navigate)="changeMonth($event)" (dateSelect)="changeDate($event)" />

<ng-template #customDay let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled"
	let-focused="focused" let-data="data">
	<app-calendar-day [date]="date" [currentMonth]="currentMonth" [focused]="focused" [data]="data | async" />
</ng-template>